import { render, staticRenderFns } from "./EditGoodsOptions.vue?vue&type=template&id=13f78b09"
import script from "./EditGoodsOptions.vue?vue&type=script&lang=js"
export * from "./EditGoodsOptions.vue?vue&type=script&lang=js"
import style0 from "./EditGoodsOptions.vue?vue&type=style&index=0&id=13f78b09&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports